<template>
  <div
    class="videoBox"
    ref="videoBox"
    :class="isFullscreen ? 'Fullscreen' : ''"
  >
    <VueDragResize
      :w="videoBoxWidth"
      :h="videoBoxHeight"
      x="0"
      y="0"
      :isResizable="false"
      :isActive="true"
      :isDraggable="!isFullscreen"
    >
      <div
        class="video_main"
        :class="!isFullscreen ? 'modal' : ''"
        :style="{
          height: isFullscreen ? '100dvh' : '3.8rem',
          width: isFullscreen ? '100dvw' : 'auto'
        }"
      >
        <!-- <video-player
          class="video-player"
          id="videoDiv"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player> -->
        <div
          style="
            width: 100%;
            height: 100%;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            v-if="isplay"
            style="width: 1rem"
            src="../assets/icons/images/apng_loadingsjb.png"
            alt=""
          />
        </div>
        <div
          v-if="!openmenus"
          style="
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            left: 0.2rem;
            top: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
          "
        >
          <svg-icon
            slot="left-icon"
            style="width: 0.4rem; height: 0.4rem"
            classNameQita
            icon-class="icon-menus"
          />
        </div>
        <div
          v-if="!openmenus"
          style="
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            right: 0.2rem;
            top: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
          "
          @click="close"
          @touchstart="close"
        >
          <svg-icon
            slot="left-icon"
            style="width: 0.4rem; height: 0.4rem"
            classNameQita
            icon-class="icon-closeBox"
          />
        </div>
        <div
          v-if="!isFullscreen && !openmenus"
          style="
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            right: 0.8rem;
            top: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
          "
          @click="toggleFullScreen"
          @touchstart="toggleFullScreen"
        >
          <svg-icon
            slot="left-icon"
            style="width: 0.4rem; height: 0.4rem"
            classNameQita
            icon-class="icon-full-screen"
          />
        </div>
        <div
          v-if="isFullscreen && !openmenus"
          style="
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            right: 0.8rem;
            top: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
          "
          @click="toggleFullScreen"
          @touchstart="toggleFullScreen"
        >
          <svg-icon
            slot="left-icon"
            style="width: 0.4rem; height: 0.4rem"
            classNameQita
            icon-class="icon-nofull-screen"
          />
        </div>
        <div
          v-if="!isplay && !openmenus"
          @click="playVideo"
          @touchstart="playVideo"
          style="
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            left: 0.2rem;
            bottom: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
          "
        >
          <svg-icon
            slot="left-icon"
            style="width: 0.4rem; height: 0.4rem"
            classNameQita
            icon-class="icon-play"
          />
        </div>
        <div
          v-if="isplay && !openmenus"
          @click="pauseVideo"
          @touchstart="pauseVideo"
          style="
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            left: 0.2rem;
            bottom: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
          "
        >
          <svg-icon
            slot="left-icon"
            style="width: 0.4rem; height: 0.4rem"
            classNameQita
            icon-class="icon-stopPlay"
          />
        </div>
        <div
          v-if="muted && !openmenus"
          @click="toggleMute"
          @touchstart="toggleMute"
          style="
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            right: 0.2rem;
            bottom: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
          "
        >
          <svg-icon
            slot="left-icon"
            style="width: 0.4rem; height: 0.4rem"
            classNameQita
            icon-class="icon-mute"
          />
        </div>
        <div
          v-if="!muted && !openmenus"
          style="
            width: 0.4rem;
            height: 0.4rem;
            position: absolute;
            right: 0.2rem;
            bottom: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
          "
          @click="toggleMute"
          @touchstart="toggleMute"
        >
          <svg-icon
            slot="left-icon"
            style="width: 0.4rem; height: 0.4rem"
            classNameQita
            icon-class="icon-noMute"
          />
        </div>
        <div
          v-if="!openmenus"
          style="
            position: absolute;
            right: 1rem;
            bottom: 0.15rem;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
            padding: 0.1rem 0.2rem;
            border-radius: 1rem;
            border: 0.01rem solid #fff;
            background: rgba(0, 0, 0, 0.7);
          "
          @click="opensignal = true"
          @touchstart="opensignal = true"
        >
          <span style="color: #fff; font-size: 0.25rem; margin-right: 0.1rem">{{
            signal
          }}</span>
          <svg-icon
            slot="left-icon"
            style="width: 0.2rem; height: 0.2rem; transition: all 0.2s ease"
            classNameQita
            icon-class="icon-down"
            :style="opensignal ? 'transform: rotate(-180deg)' : ''"
          />
        </div>
        <div
          v-if="opensignal || openmenus"
          style="
            position: absolute;
            top: 0;
            left: 0;
            z-index: 100;
            color: #fff;
            font-size: 0.3rem;
            width: 100%;
            height: 100%;
          "
          @click="(opensignal = false), (openmenus = false)"
          @touchstart="(opensignal = false), (openmenus = false)"
        >
          <div
            v-if="openmenus"
            style="
              position: absolute;
              top: 0;
              left: 0;
              z-index: 100;
              color: #fff;
              font-size: 0.3rem;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.7);
            "
          >
            <div
              style="padding: 0 0.8rem; height: 100%; overflow-y: scroll"
              :class="isFullscreen ? 'Fullscreenmenus' : ''"
            >
              <div class="_title_1i1eq_77">
                <div class="_decorate_1i1eq_89 _left_1i1eq_113"></div>
                <span class="_other-match_1i1eq_84"
                  >Outras transmissões ao vivo</span
                >
                <div class="_decorate_1i1eq_89 _right_1i1eq_116"></div>
              </div>
              <div
                v-if="!isFullscreen"
                style="
                  width: 0.4rem;
                  height: 0.4rem;
                  position: absolute;
                  right: 0.22rem;
                  top: 0.22rem;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  z-index: 100;
                "
              >
                <svg-icon
                  slot="left-icon"
                  style="width: 0.4rem; height: 0.4rem"
                  classNameQita
                  icon-class="icon-closeBox"
                />
              </div>
              <li v-for="ite in 7" class="_item_1mx2s_45">
                <div class="_team-name_1mx2s_80">
                  <span class="_inner-team-name_1mx2s_85">Fagiano Okayama</span>
                  <div class="_team-logo_1mx2s_102">
                    <img
                      class="_home-team-logo_1mx2s_108"
                      src="https://gs.lunchpg.com/sport/202/team/11299/ad39f54b8e0412539242b8184f886659.png"
                      alt="."
                    />
                    <svg-icon
                      slot="left-icon"
                      style="width: 0.2rem; height: 0.2rem"
                      classNameQita
                      icon-class="icon-vs_logo"
                    />
                    <img
                      class="_away-team-logo_1mx2s_108"
                      src="https://gs.lunchpg.com/sport/202/team/10893/7829b7fb1e6b157a98afddf9bed02808.png"
                      alt="."
                    />
                  </div>
                  <span class="_inner-team-name_1mx2s_85"
                    >Pílula de sucesso de Nagasaki</span
                  >
                </div>
                <div class="_match-time_1mx2s_115">
                  <span class="_time_1mx2s_120">21/03 13:00</span
                  ><span class="_place-ele_1mx2s_133">
                    <svg-icon
                      slot="left-icon"
                      style="width: 0.2rem; height: 0.2rem; color: red"
                      classNameQita
                      icon-class="icon-over_logo"
                    />
                  </span>
                </div>
              </li>
            </div>
          </div>
          <div
            v-if="opensignal"
            style="
              position: absolute;
              right: 1rem;
              bottom: 0.68rem;
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 100;
              padding: 0.1rem 0.2rem;
              border-radius: 0.1rem;
              border: 0.01rem solid #fff;
              background: rgba(0, 0, 0, 0.7);
            "
          >
            <van-radio-group v-model="signal">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                @click="signal = 'Inglês_1'"
                @touchstart="signal = 'Inglês_1'"
              >
                <span style="margin-right: 0.1rem">Inglês_1</span>
                <van-radio name="Inglês_1" checked-color="#fff"></van-radio>
              </div>

              <div
                style="
                  width: 100%;
                  height: 0.01rem;
                  background-color: #fff;
                  margin: 0.1rem 0;
                "
              ></div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
                @click="signal = 'Inglês_2'"
                @touchstart="signal = 'Inglês_2'"
              >
                <span style="margin-right: 0.1rem">Inglês_2</span
                ><van-radio name="Inglês_2" checked-color="#fff"></van-radio>
              </div>
            </van-radio-group>
          </div>
        </div>
      </div>
    </VueDragResize>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player';
import 'videojs-contrib-hls'; // 引入HLS插件
import VueDragResize from 'vue-drag-resize';
export default {
  components: { videoPlayer, VueDragResize },
  props: {},
  data() {
    return {
      signal: 'Inglês_1',
      openmenus: false,
      opensignal: false,
      isFullscreen: false,
      player: null,
      isplay: false,
      muted: true,
      playerOptions: {
        // playbackRates: [0.5, 1.0, 1.5, 2.0],
        autoplay: false,
        muted: true,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        sources: [
          //   {
          //     type: 'video/mp4',
          //     src: require('../assets/football.mp4')
          //   }
          {
            type: 'application/x-mpegURL',
            src: ''
          }
        ],
        poster: '', // 封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: 'loading......' //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      videoBoxWidth: 0,
      videoBoxHeight: 0
    };
  },
  computed: {},
  watch: {
    src: {
      handler(newval) {
        this.playerOptions.sources[0].src = newval;
        this.srcvideo = newval;
      }
    }
  },
  created() {},
  mounted() {
    // this.player = this.$refs.videoPlayer.player;
    this.videoBoxWidth = this.$refs.videoBox.offsetWidth;
    this.videoBoxHeight = this.$refs.videoBox.clientHeight;
  },
  methods: {
    close() {
      setTimeout(() => {
        this.$store.state.isShowVideoPlayBox = false;
      }, 100);
    },
    playVideo() {
      this.isplay = true;
      // this.player.play();
    },
    pauseVideo() {
      this.isplay = false;
      // this.player.pause();
    },
    toggleMute() {
      // if (this.player) {
      this.muted = !this.muted;
      // this.player.muted(this.player.muted() ? false : true); // 切换静音状态
      // }
    },
    toggleFullScreen() {
      this.isFullscreen = !this.isFullscreen;
      const modal = this.$el.querySelector('.modal');
      modal.style.left = 0;
      modal.style.top = 0;
    }
  }
};
</script>

<style scoped>
.videoBox {
  width: calc(var(--theme-max-width) - 0.6rem);
  max-width: calc(100dvw - 0.6rem);
  position: fixed;
  top: 30%;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: 10000;
}
.Fullscreen {
  width: 100dvw;
  max-width: 100dvw;
  height: 100dvh;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .vdr {
    top: 0 !important;
    left: 0 !important;
  }
}
.video_main {
  width: 100%;
  height: 3.8rem;
  position: relative;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(../assets/icons/images/videoBg.png);
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}
.modal {
  cursor: pointer;
}
.vdr.active:before {
  outline: none;
}
.Fullscreenmenus {
  width: 5rem;
  padding: 0 0.2rem !important;
  border-right: 0.01rem solid #fff;
}
._title_1i1eq_77 {
  display: flex;
  flex: 2;
  align-items: center;
  justify-content: center;
}
._other-match_1i1eq_84 {
  margin: 0.1rem;
  font-size: 0.25rem;
}
._title_1i1eq_77 ._decorate_1i1eq_89 {
  position: relative;
  width: 0.1rem;
  height: 0.1rem;
}
._title_1i1eq_77 ._decorate_1i1eq_89:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 0.1rem;
  height: 0.1rem;
  background-color: #fff;
  transform: rotate(45deg);
  content: '';
}
._title_1i1eq_77 ._decorate_1i1eq_89:after {
  position: absolute;
  top: 0.025rem;
  right: 0;
  width: 1rem;
  height: 0.05rem;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 1%,
    #fff 99%
  );
  content: '';
}
._right_1i1eq_116 {
  transform: rotate(180deg);
}
._item_1mx2s_45 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 0.3rem);
  height: 0.6rem;
  margin: 0 auto 0.2rem;
  padding: 0 0.1rem;
  font-size: 0.2rem;
  background-color: rgba(0, 0, 0, 0.5);
  border: solid thin rgba(255, 255, 255, 0.3);
  border-radius: 0.1rem;
  cursor: pointer;
  ._team-name_1mx2s_80 {
    display: flex;
    align-items: center;
    justify-content: center;
    ._inner-team-name_1mx2s_85:nth-of-type(1) {
      text-align: right;
    }
    ._inner-team-name_1mx2s_85 {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      width: 1.2rem;
    }
    ._team-logo_1mx2s_102 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 0.9rem;
      margin: 0 0.15rem;
      ._home-team-logo_1mx2s_108,
      ._away-team-logo_1mx2s_108 {
        width: 0.3rem;
      }
    }
  }
  ._match-time_1mx2s_115 {
    display: flex;
    align-items: center;
    margin-left: 0.1rem;
    ._time_1mx2s_120 {
      margin: 0 0.1rem;
      text-align: center;
    }
  }
}
.svg-icon {
  color: #fff;
}
:deep(.van-radio__icon--checked .van-icon) {
  color: #000 !important;
}
:deep(.video-player) {
  width: 100%;
  height: auto;
}
:deep(.vjs-modal-dialog-content) {
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.vjs-error-display:before) {
  display: none;
}
:deep(.video-js .vjs-big-play-button) {
  display: none !important;
}
:deep(.video-js .vjs-control-bar) {
  display: none !important;
}

/* 视频封面 */
:deep(.video-js .vjs-poster) {
  background-size: cover !important;
}
</style>
